import * as React from 'react';
import { Row, Col, Input, Modal, Button } from 'antd';
import strings from '../../eyeguide-localization/strings.settings';
import '../../css/UpdatePassword.scss';
import service from '../../service/apolloclient.service';
import Constants from '../common/constants';
import Utils from '../common/utils';

interface IUpdatePasswordProps {
    isModalVisible: boolean;
    modalClosed: any;
}

interface IUpdatePasswordState {
    oldPwd: string;
    newPwd: string;
    confirmPwd: string;
    classesWithErr: string;
    classesWithoutErr: string;
    errorOld:    boolean;
    errorNew: boolean;
    errorConfirm: boolean;
    isSuccess: boolean;
    isModalVisible: boolean;
    errorUnmatched: boolean;
    errorWrongPwd: boolean;
    errorPwdCriteria: boolean;
}

export default class UpdatePassword extends React.Component<IUpdatePasswordProps, IUpdatePasswordState> {
    oldPwdRef: any;
    constructor(props: IUpdatePasswordProps) {
        super(props);
        this.state = {
            oldPwd: '',
            newPwd: '',
            confirmPwd: '',
            classesWithErr: 'fill errorHighlight',
            classesWithoutErr: 'fill',
            errorOld:    false,
            errorNew: false,
            errorConfirm: false,
            isSuccess: false,
            isModalVisible: this.props.isModalVisible,
            errorUnmatched: false,
            errorWrongPwd: false,
            errorPwdCriteria: false
        };
    }

    componentWillReceiveProps(nextProps: any) {

        this.setState({
            isModalVisible: nextProps.isModalVisible
        });
        console.log('ref', this.oldPwdRef);
        if (nextProps.isModalVisible) {
            setTimeout(() => {this.oldPwdRef.focus() ; }, 1);
        }
    }

    render() {
        return (
            <Modal
                className="UpdatePassword"
                title={this.state.isSuccess ? strings.lsSuccessTxt : strings.lsUpdatePwdTxt}
                visible={this.state.isModalVisible}
                width={800}
                bodyStyle={{padding: 0 }}
                maskClosable={false}
                closable={false}
                footer={!this.state.isSuccess ? [
                    <Button 
                            key="Ok" 
                            type="primary"  
                            onClick={() => this.updatePassword()}
                    >
                    {this.state.isSuccess ? strings.lsOkTxt : strings.lsUpdatePwdTxt}
                    </Button>,
                    <Button 
                            key="cancel" 
                            type="danger"  
                            onClick={() => this.closeForm()}
                    >
                        {strings.lsCancelTxt}
                    </Button>
                ] : [
                    <Button 
                        key="Ok" 
                        type="primary"  
                        onClick={() => this.updatePassword()}
                    >
                    {strings.lsOkTxt}
                    </Button>,
                ]}
            >
            {this.state.isSuccess ?
                <div className="successDiv">
                    {strings.lsUpdatePwdSuccessTxt}
                </div>
             :
                <div className="inputdiv">
                    <Row className="row">
                        <Col xs={1} sm={1} md={4} lg={4} xl={4} />
                        <Col xs={8} sm={8} md={6} lg={6} xl={4} className="labelFrame">
                            <div className="label">
                                <span> {strings.lsOldPassword}
                                    <span className="labelReq"> * </span>
                                :</span>
                            </div>
                        </Col>
                        
                            <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                                <Input 
                                    ref={val => this.oldPwdRef = val}
                                    value={this.state.oldPwd}
                                    onChange={(val) => this.setState({oldPwd: val.target.value})}
                                    className={this.state.errorOld ? 
                                            this.state.classesWithErr : this.state.classesWithoutErr}
                                    autoFocus={true}
                                    type="password" 
                                />
                            </Col>
                        <Col xs={1} sm={1} md={4} lg={4} xl={4}/>                   
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={4} lg={4} xl={4} />
                        <Col xs={8} sm={8} md={6} lg={6} xl={4} className="labelFrame">
                            <div className="label">
                                <span> {strings.lsNewPassword}
                                    <span className="labelReq"> * </span>
                                :</span>
                            </div>
                        </Col>
                        
                            <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                                <Input 
                                    value={this.state.newPwd}
                                    onChange={(val) => this.setState({newPwd: val.target.value})}
                                    className={this.state.errorNew ? 
                                            this.state.classesWithErr : this.state.classesWithoutErr}
                                    type="password" 
                                />
                            </Col>
                        <Col xs={1} sm={1} md={4} lg={4} xl={4}/>                   
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={4} lg={4} xl={3} />
                        <Col xs={8} sm={8} md={6} lg={6} xl={5} className="labelFrame">
                            <div className="label">
                                <span> {strings.lsConfirmPwd}
                                    <span className="labelReq"> * </span>
                                :</span>
                            </div>
                        </Col>
                        
                            <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                                <Input 
                                    value={this.state.confirmPwd}
                                    onChange={(val) => this.setState({confirmPwd: val.target.value})}
                                    className={this.state.errorConfirm ? 
                                            this.state.classesWithErr : this.state.classesWithoutErr}
                                    type="password" 
                                />
                            </Col>
                        <Col xs={1} sm={1} md={4} lg={4} xl={4}/>                   
                    </Row>
                    {this.state.errorUnmatched || this.state.errorPwdCriteria ? 
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={3} />
                        <Col xs={8} sm={8} md={5} lg={3} xl={5} className="errorFrame"/>                        
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                            <span className="error">
                                {this.state.errorUnmatched ? strings.lsPwdMismatchTxt
                                    : strings.lsResetPwdInputHeadingTxt
                                }
                            </span>
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>                   
                    </Row>
                    : ''}
                    {this.state.errorWrongPwd ? 
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={3} />
                        <Col xs={8} sm={8} md={5} lg={3} xl={5} className="errorFrame"/>                        
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                            <span className="error">
                                {strings.lsWrongPwd}
                            </span>
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>                   
                    </Row>
                    : ''}
                </div>
            }
            </Modal>
        );
    }

    private async updatePassword() {
        console.log('updated');

        if (!this.state.isSuccess) {
            if (this.validateInput()) {
                let ser = new service();
                let resp = await ser.changePassword(this.getChangePwdInput());
                console.log('updatePasswordReponse', resp);
                if (resp.status === 0) {
                    this.setState({
                        isSuccess: true
                    });
                    
                } else if (Constants.getErrorText().ERROR_WRONG_PWD === resp.message) {
                    this.setState({
                        errorWrongPwd: true
                    });
                } else  {
                    console.log('not changed');
                }
            }
        } else {
            this.setState({
                isModalVisible: false
            });
            this.clearForm();
        }
    
    }

    private getChangePwdInput() {
        let input: any = {
            oldPassword: this.state.oldPwd,
            newPassword: this.state.newPwd
        };
        return input;
    }

    private clearForm() {
        this.setState({
            oldPwd: '',
            newPwd: '',
            confirmPwd: '',
            isSuccess: false,
            errorUnmatched: false,
            errorNew: false,
            errorOld: false,
            errorConfirm: false,
            errorWrongPwd: false,
            errorPwdCriteria: false
        });
        this.props.modalClosed();
    }

    private closeForm() {
     this.setState({
         isModalVisible: false
     });
     this.clearForm();
    }

    private validateInput() {
        let isValid: boolean = true;
        let errorNew: boolean = false;
        let errorOld: boolean = false;
        let errorConfirm: boolean = false;
        let errorUnmatched: boolean = false;
        let errorPwdCriteria: boolean = false;

        if (this.state.oldPwd !== null && 
                    (this.state.oldPwd === undefined || this.state.oldPwd.trim() === '' )) {   
            errorOld = true;
            console.log('this.state.errorFname', this.state.errorOld);
        } else {
            errorOld = false;
        }      
        if (this.state.newPwd !== null && 
                    (this.state.newPwd === undefined || this.state.newPwd.trim() === '')) {
            errorNew = true;
        } else if (!Utils.validatePassword(this.state.newPwd)) {
            errorNew = true;
            errorPwdCriteria = true;
        } else {
            errorNew = false;
        }
        if (this.state.confirmPwd !== null && 
            (this.state.confirmPwd === undefined || this.state.confirmPwd.trim() === '')) {
            errorConfirm = true;
        } else {
            errorConfirm = false;
        }

        if (!errorConfirm && !errorNew) {
            if (this.state.confirmPwd !== this.state.newPwd) {
                errorUnmatched = true;
            } else { errorUnmatched = false; }
        }

        if (errorConfirm || errorNew || errorOld || errorUnmatched) {           
            isValid = false;
        } 
        this.setState({errorConfirm, errorNew, errorOld, errorUnmatched, errorPwdCriteria });
        return isValid;
    }

}



// WEBPACK FOOTER //
// ./src/components/settings/updatePassword.tsx